import { isPlatformServer, DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, PLATFORM_ID, InjectionToken } from '@angular/core';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { AlgoliaClientService } from '@wizbii/algolia';
import { Observable, zip, of, throwError, from, combineLatest } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpRequest, HttpHeaders, HttpEventType, HttpResponse } from '@angular/common/http';
import { buildUrl, readBlob, WINDOW } from '@wizbii/angular-utilities';
import { toUserOverview, toContact, WizFile, City, Address, toJob, toAdmiinJob, ArticleTypes, toIdentityCard, LocaleEnum, toOpsEvent, toOpsEventLight } from '@wizbii/models';
import { map, switchMap, mergeMap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@wizbii/algolia';
import * as ɵngcc2 from '@angular/platform-browser';
import * as ɵngcc3 from '@angular/common/http';
class AlgoliaWebservice {
    constructor(algoliaClientService, transferState, platformId) {
        this.algoliaClientService = algoliaClientService;
        this.transferState = transferState;
        this.platformId = platformId;
        this.nbRequest = 0;
    }
    /**
     * get algolia pagination
     * @param {string} index algolia index
     * @param {string} query query and key words
     * @param {Array} facetFilters filters applyed on index attributes
     * @param {string} length number of hits returned
     * @param {string} offset offeset applyed on result
     * @param {string} filters filters applyed on index objects
     * @param {string} aroundLatLng apply a range filter 'lat, lng'.
     */
    searchByKeyWords(index, query = '', facetFilters = [], length = 6, offset = 0, filters = '', aroundLatLng = '') {
        const algoliaIndex = this.algoliaClientService.client.initIndex(index);
        const params = {
            facetFilters,
            offset,
            length,
            filters,
            facets: '*',
            aroundLatLng,
        };
        return new Observable((observer) => {
            const ALGOLIA_KEY = makeStateKey(`algolia-${index}-${this.nbRequest}`);
            this.nbRequest++;
            if (this.transferState.hasKey(ALGOLIA_KEY)) {
                const content = this.transferState.get(ALGOLIA_KEY, null);
                this.transferState.remove(ALGOLIA_KEY);
                observer.next(content);
                observer.complete();
            }
            else {
                algoliaIndex
                    .search(query, params)
                    .then((content) => {
                    if (isPlatformServer(this.platformId)) {
                        this.transferState.set(ALGOLIA_KEY, content);
                    }
                    observer.next(content);
                    observer.complete();
                })
                    .catch((err) => {
                    observer.error(err);
                });
            }
        });
    }
}
AlgoliaWebservice.ɵfac = function AlgoliaWebservice_Factory(t) { return new (t || AlgoliaWebservice)(ɵngcc0.ɵɵinject(ɵngcc1.AlgoliaClientService), ɵngcc0.ɵɵinject(ɵngcc2.TransferState), ɵngcc0.ɵɵinject(PLATFORM_ID)); };
AlgoliaWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AlgoliaWebservice, factory: AlgoliaWebservice.ɵfac });
AlgoliaWebservice.ctorParameters = () => [
    { type: AlgoliaClientService },
    { type: TransferState },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlgoliaWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.AlgoliaClientService }, { type: ɵngcc2.TransferState }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

var AuthenticationApiError;
(function (AuthenticationApiError) {
    AuthenticationApiError["InvalidOldPasswordException"] = "InvalidOldPasswordException";
    AuthenticationApiError["PasswordTooWeakException"] = "PasswordTooWeakException";
    AuthenticationApiError["PasswordAlreadySetException"] = "PasswordAlreadySetException";
})(AuthenticationApiError || (AuthenticationApiError = {}));
const AUTHENTICATION_API_CONFIG = new InjectionToken('AUTHENTICATION_API_CONFIG');
class AuthenticationWebservice {
    constructor(http, { appId, baseUrl, locale }) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.appId = appId;
        this.locale = locale;
    }
    /**
     * Refresh the jwt
     * @param {Object} tokens Jwt and refresh token
     * @param {Object} [options] Angular Options for the request
     */
    refreshToken(tokens, options) {
        return this.http.post(`${this.baseUrl}/v1/jwt/refresh`, {
            appId: this.appId,
            token: tokens.token,
            refreshToken: tokens.refreshToken,
        }, options);
    }
    /**
     * Get jwt and refresh token for an application
     * @param {string} username Username to sign in
     * @param {string} password Password to sign in
     * @param {Object} [options] Angular Options for the request
     */
    signIn(username, password, options) {
        return this.http.post(`${this.baseUrl}/auth`, {
            username,
            password,
            appId: this.appId,
        }, options);
    }
    /**
     * Send an email to recover the password
     * @param {string} email Email to send the password recover link
     * @param {string} [redirectUrl] Redirect url after recovery is completed
     * @param {string} [appId] appId from where the redirection is headed
     * @param {Object} [options] Angular Options for the request
     */
    getRecoveryEmail(email, redirectUrl, appId, options) {
        return this.http.post(`${this.baseUrl}/v1/user/lost-password`, {
            email,
            redirectUrl,
            appId: appId ? appId : this.appId,
        }, options);
    }
    /**
     * Change the password with a token
     * @param {string} passwordToken Token to recover the password
     * @param {string} password New password to set
     * @param {Object} [options] Angular Options for the request
     */
    recoverPassword(passwordToken, password, options) {
        return this.http.post(buildUrl(`${this.baseUrl}/v1/user/lost-password/:passwordToken`, { passwordToken }), {
            password,
            appId: this.appId,
        }, options);
    }
    /**
     * Get an overview of an User
     * @param {string} id Id of the User
     * @param {Object} [options] Angular Options for the request
     */
    getUserOverview(id, options) {
        return this.http
            .get(buildUrl(`${this.baseUrl}/v1/user/:id/overview`, { id }), options)
            .pipe(map(toUserOverview));
    }
    /**
     * Change the email of an User
     * @param {string} id Id of the User
     * @param {string} email Email of the User
     * @param {Object} [options] Angular Options for the request
     */
    changeEmail(id, email, options) {
        return this.http.put(buildUrl(`${this.baseUrl}/v1/user/:id/email`, { id, email }), {
            email,
            appId: this.appId,
        }, options);
    }
    /**
     * Change the password of an User
     * @param {string} id Id of the User
     * @param {string} oldPassword Old password of the user
     * @param {string} newPassword New password of the User
     * @param {Object} [options] options Angular Options for the request
     */
    changePassword(id, oldPassword, newPassword, options) {
        return this.http.put(buildUrl(`${this.baseUrl}/v1/user/:id/password`, { id }), {
            oldPassword,
            newPassword,
            appId: this.appId,
        }, options);
    }
    /**
     * Set the password of an User
     * @param {string} id Id of the User
     * @param {string} newPassword Password of the User
     * @param {string} [redirectUrl] Redirect url after password is set
     * @param {Object} [options] options Angular Options for the request
     */
    setPassword(id, newPassword, redirectUrl, options) {
        return this.http.post(buildUrl(`${this.baseUrl}/v1/user/:id/password/set`, { id }), {
            newPassword,
            appId: this.appId,
            redirectUrl,
        }, options);
    }
    /**
     * Set a random password for an user
     * @param {string} id Id of the User
     * @param {Object} [options] options Angular Options for the request
     */
    hardResetPassword(id, options) {
        return this.http.post(`${this.baseUrl}/v1/user/${id}/password/reset`, options);
    }
    /**
     * Get Jwt from login token
     * @param {string} loginToken login token of the user
     * @param {Object} [options] Angular Options for the request
     */
    getJwtFromLoginToken(loginToken, options) {
        return this.http.post(`${this.baseUrl}/v1/auth/login-token`, {
            loginToken,
            appId: this.appId,
        }, options);
    }
    /**
     * Get login token from profile od
     * @param {string} profileId profile id of the user
     */
    getLoginTokenByProfileId(profileId, duration, options) {
        return this.http.post(`${this.baseUrl}/v1/user/${profileId}/login-token`, { duration }, options);
    }
    /**
     * Get recovery token from user id
     * @param {string} userId user id
     */
    getRecoveryTokenByUserId(userId, options) {
        return this.http.get(`${this.baseUrl}/v1/user/${userId}/recovery-token`, options);
    }
    /**
     * Send password reset email
     * @param email {string} user's email address
     * @param appId {string}
     * @param {Object} [options] Angular Options for the request
     */
    sendResetPasswordEmail(email, appId, options) {
        return this.http.post(`${this.baseUrl}/v1/user/lost-password`, { email, appId }, options);
    }
    /**
     * Unlink an authentication from the user
     * @param {string} id Id of the User
     * @param {string} authenticationType Type of the authentication to unlink
     * @param {Object} [options] options Angular Options for the request
     */
    unlinkSocial(id, authenticationType, options) {
        const builtOptions = Object.assign(Object.assign({}, options), { body: { type: authenticationType } });
        return this.http.delete(buildUrl(`${this.baseUrl}/v1/user/:id/authentication`, { id }), builtOptions);
    }
    /**
     * Associate user's account with Apple
     * @param {string} id Id of the User
     * @param {SignInWithAppleData} appleData
     * @param {Object} [options] options Angular Options for the request
     */
    associateApple(id, appleData, options) {
        return this.http.post(buildUrl(`${this.baseUrl}/associate/${id}/apple`), Object.assign(Object.assign({}, appleData), { locale: this.locale, appId: this.appId }), options);
    }
    /**
     * Associate user's account with Google
     * @param {string} id Id of the User
     * @param {string} authCode return from google connect SDK
     * @param {Object} [options] options Angular Options for the request
     */
    associateGoogle(id, authCode, options) {
        return this.http.post(buildUrl(`${this.baseUrl}/associate/${id}/google`), {
            authCode,
            locale: this.locale,
            appId: this.appId,
        }, options);
    }
    /**
     * Associate user's account with Facebook
     * @param {string} id Id of the User
     * @param {string} accessToken return from facebook SDK
     * @param {Object} [options] options Angular Options for the request
     */
    associateFacebook(id, accessToken, options) {
        return this.http.post(buildUrl(`${this.baseUrl}/associate/${id}/facebook`), {
            accessToken,
            locale: this.locale,
            appId: this.appId,
        }, options);
    }
}
AuthenticationWebservice.ɵfac = function AuthenticationWebservice_Factory(t) { return new (t || AuthenticationWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(AUTHENTICATION_API_CONFIG)); };
AuthenticationWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AuthenticationWebservice, factory: AuthenticationWebservice.ɵfac });
AuthenticationWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [AUTHENTICATION_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuthenticationWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [AUTHENTICATION_API_CONFIG]
            }] }]; }, null); })();

const CONTACT_API_CONFIG = new InjectionToken('CONTACT_API_CONFIG');
class ContactWebservice {
    constructor(http, { appId, baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.appId = appId;
    }
    /**
     * Send an email from a contat form
     * @param {Object} contact Object defining the contact
     * @param {Object} [options] Angular Options for the request
     */
    send(contact, options) {
        return this.http
            .post(`${this.baseUrl}/v1/contact`, Object.assign(Object.assign({}, contact), { appId: this.appId }), options)
            .pipe(map(toContact));
    }
}
ContactWebservice.ɵfac = function ContactWebservice_Factory(t) { return new (t || ContactWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(CONTACT_API_CONFIG)); };
ContactWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ContactWebservice, factory: ContactWebservice.ɵfac });
ContactWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [CONTACT_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContactWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [CONTACT_API_CONFIG]
            }] }]; }, null); })();

const FILE_API_CONFIG = new InjectionToken('FILE_API_CONFIG');
class FileWebservice {
    constructor(http, { baseUrl, googleStorageUrl, wizbiiFilesBucket }) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.googleStorageUrl = googleStorageUrl;
        this.wizbiiFilesBucket = wizbiiFilesBucket;
    }
    /**
     * Create a file and send it to GCS and needed API
     * @param {Object} file File to create
     * @param {Object} [options] Angular Options for the request
     */
    create(file, options) {
        const res = /\.(\w+)$/.exec(file.domFile.name);
        const uploadUrlResponse$ = this.http.post(`${this.baseUrl}/v1/file`, {
            fileExtension: res && res.length > 0 ? res[1] : '',
            contentType: file.domFile.type,
            public: true,
        }, options);
        const buffer$ = readBlob(file.domFile);
        return zip(buffer$, uploadUrlResponse$).pipe(switchMap(([buffer, uploadUrlResponse]) => {
            const req = new HttpRequest('PUT', uploadUrlResponse.uploadUrl, buffer, {
                headers: new HttpHeaders(Object.assign(Object.assign({}, (options ? options.headers : {})), { 'Content-Type': file.domFile.type })),
                reportProgress: true,
            });
            return this.http.request(req).pipe(mergeMap((event) => event.type === HttpEventType.Response
                ? this.http.post(uploadUrlResponse.successUrl, null, options).pipe(map(() => new HttpResponse({
                    body: new WizFile(Object.assign(Object.assign({}, file), { id: uploadUrlResponse.fileId })),
                })))
                : of(event)));
        }));
    }
    /**
     * Create a blob from a file id
     * @param {string} fileId Id of the file
     * @param {Object} [options] Angular Options for the request
     */
    getDownloadBlob(fileId, options) {
        const url = `${this.googleStorageUrl}/${this.wizbiiFilesBucket}/${fileId}`;
        return this.http.get(url, Object.assign(Object.assign({}, options), { responseType: 'blob' }));
    }
    /**
     * Build public URL from a file id
     * @param {string} fileId Id of the file
     */
    getFileUrl(fileId) {
        return `${this.googleStorageUrl}/${this.wizbiiFilesBucket}/${fileId}`;
    }
    /**
     * Delete a file with the id
     * @param {string} fileId Id of the file
     * @param {Object} [options] Angular Options for the request
     */
    delete(fileId, options) {
        const url = `${this.baseUrl}/v1/file/${fileId}`;
        return this.http.delete(url, options);
    }
}
FileWebservice.ɵfac = function FileWebservice_Factory(t) { return new (t || FileWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(FILE_API_CONFIG)); };
FileWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FileWebservice, factory: FileWebservice.ɵfac });
FileWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [FILE_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [FILE_API_CONFIG]
            }] }]; }, null); })();

const PLACE_API_CONFIG = new InjectionToken('PLACE_API_CONFIG');
class CityWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    /**
     * Get a city
     * @param {string} id Id of the city
     * @param {Object} [options] Angular Options for the request
     */
    get(id, options) {
        return this.http
            .get(buildUrl(`${this.baseUrl}/v2/location/?:id`, { id }), options)
            .pipe(map((item) => new City(item)));
    }
    /**
     * Get places objects with parameters
     * @param {Object} params  The query, the countries to restrict, the type
     * @param {Object} [options] Angular Options for the request
     */
    getBy({ query, countries, type, language }, options) {
        const url = buildUrl(`${this.baseUrl}/v2/location`, Object.assign(Object.assign(Object.assign(Object.assign({}, (query ? { name: query } : {})), (type ? { type } : {})), (countries && countries.length ? { countries: countries.join() } : {})), (language ? { language } : {})));
        return this.http
            .get(url, options)
            .pipe(map((items) => (items || []).map((item) => new City(item))));
    }
    /**
     * Get address objects with parameters
     * @param {Object} params  The query, the countries to restrict, the type
     * @param {Object} [options] Angular Options for the request
     */
    getAddressBy({ query, countries, type, language }, options) {
        const url = buildUrl(`${this.baseUrl}/v2/address`, Object.assign(Object.assign(Object.assign(Object.assign({}, (query ? { name: query } : {})), (type ? { type } : {})), (countries && countries.length ? { countries: countries.join() } : {})), (language ? { language } : {})));
        return this.http
            .get(url, options)
            .pipe(map((items) => (items || []).map((item) => new Address(item))));
    }
    /**
     * Get places objects with parameters
     * @param {Object} params  The query, the countries to restrict, the type
     * @param {Object} [options] Angular Options for the request
     */
    getReverse({ position }, options) {
        const url = buildUrl(`${this.baseUrl}/v2/location/reverse`, Object.assign({}, (position ? { lat: position.lat.toString(10), long: position.long.toString(10) } : {})));
        return this.http.get(url, options).pipe(map((cities) => (cities || []).map((city) => new City(city))), map((cities) => cities.find((item) => item.city !== null)));
    }
}
CityWebservice.ɵfac = function CityWebservice_Factory(t) { return new (t || CityWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(PLACE_API_CONFIG)); };
CityWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CityWebservice, factory: CityWebservice.ɵfac });
CityWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [PLACE_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CityWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLACE_API_CONFIG]
            }] }]; }, null); })();

const PROFILE_API_CONFIG = new InjectionToken('PROFILE_API_CONFIG');
class ProfileWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    /**
     * get a profile
     * @param {string} id Profile id
     * @param {Object} [options] Angular Options for the request
     */
    get(id, options) {
        return this.http.get(buildUrl(`${this.baseUrl}/api/profiles/:id`, { id }), options);
    }
    /**
     * Update a profile
     * @param {string} profileId ID of the user
     * @param {Object} profile new profile
     * @param {Object} [options] Angular Options for the request
     */
    updateProfile(profileId, profile, options) {
        return this.http.patch(`${this.baseUrl}/api/profiles/${profileId}`, Object.assign({}, profile), options);
    }
}
ProfileWebservice.ɵfac = function ProfileWebservice_Factory(t) { return new (t || ProfileWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(PROFILE_API_CONFIG)); };
ProfileWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ProfileWebservice, factory: ProfileWebservice.ɵfac });
ProfileWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [PROFILE_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProfileWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [PROFILE_API_CONFIG]
            }] }]; }, null); })();

const COMPANY_API_CONFIG = new InjectionToken('COMPANY_API_CONFIG');
class CompanyWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    /**
     * Get a Wizbii company
     * @param {string} id Id of the company
     * @param {Object} [options] Angular Options for the request
     */
    get(id, options) {
        return this.http.get(buildUrl(`${this.baseUrl}/v1/company/:id`, { id }), options);
    }
    /**
     * Get a Wizbii company in admin format
     * @param {string} id Id of the company
     * @param {Object} [options] Angular Options for the request
     */
    adminGet(id, options) {
        return this.http.get(buildUrl(`${this.baseUrl}/v1/admin/company/:id`, { id }), options);
    }
    /**
     * Update a Wizbii company
     * @param {string} id id of company to update
     * @param {Company} company Company to update
     * @param {Object} [options] Angular Options for the request
     */
    updateCompany(id, company, options) {
        return this.http.put(`${this.baseUrl}/v1/admin/company/${id}`, company, options);
    }
    getRecruiter(recruiterId) {
        return this.http.get(`${this.baseUrl}/v1/recruiter/${recruiterId}`);
    }
    updateRecruiter(recruiter, options) {
        return this.http.put(`${this.baseUrl}/v1/recruiter/${recruiter.id}`, recruiter, options);
    }
}
CompanyWebservice.ɵfac = function CompanyWebservice_Factory(t) { return new (t || CompanyWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(COMPANY_API_CONFIG)); };
CompanyWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CompanyWebservice, factory: CompanyWebservice.ɵfac });
CompanyWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [COMPANY_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CompanyWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [COMPANY_API_CONFIG]
            }] }]; }, null); })();

const JOB_API_CONFIG = new InjectionToken('JOB_API_CONFIG');

class ContractWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    /**
     * Get the contracts for a Job according to the locale
     * @param {string} [locale=fr_FR] Locale for the contracts
     * @param {Object} [options] Angular Options for the request
     */
    get(locale, options) {
        return this.http.get(buildUrl(`${this.baseUrl}/api/contracts`, { locale }), options);
    }
}
ContractWebservice.ɵfac = function ContractWebservice_Factory(t) { return new (t || ContractWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(JOB_API_CONFIG)); };
ContractWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ContractWebservice, factory: ContractWebservice.ɵfac });
ContractWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [JOB_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContractWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [JOB_API_CONFIG]
            }] }]; }, null); })();

class JobWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    get(id, options) {
        return this.http.get(`${this.baseUrl}/api/jobs/${id}?view=true`, options).pipe(map(toJob));
    }
    getAdmiin(id, options) {
        return this.http
            .get(`${this.baseUrl}/api/admin/jobs/${id}`, options)
            .pipe(map(toAdmiinJob));
    }
    getBatch(ids, options) {
        const queryParam = ids.join(',');
        return this.http
            .get(`${this.baseUrl}/api/jobs/${queryParam}`, options)
            .pipe(map((items) => items.map(toJob)));
    }
    updateAdmiinJob(job, options) {
        return this.http.post(buildUrl(`${this.baseUrl}/api/jobs`), job, options).pipe(map(toAdmiinJob));
    }
    getDomains(options) {
        return this.http.get(buildUrl(`${this.baseUrl}/api/domains/jobs`), options);
    }
    deleteAllJobsByCompanyId(company) {
        return this.http.post(buildUrl(`${this.baseUrl}/api/company/${company.id}/jobs/delete`), null);
    }
    deleteOfflineJobsByCompanyId(company) {
        return this.http.post(buildUrl(`${this.baseUrl}/api/company/${company.id}/jobs-offline/delete`), null);
    }
}
JobWebservice.ɵfac = function JobWebservice_Factory(t) { return new (t || JobWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(JOB_API_CONFIG)); };
JobWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: JobWebservice, factory: JobWebservice.ɵfac });
JobWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [JOB_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JobWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [JOB_API_CONFIG]
            }] }]; }, null); })();

const SCHOOL_API_CONFIG = new InjectionToken('SCHOOL_API_CONFIG');

class DegreeWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    /**
     * Get the degrees according to the locale
     * @param {string} [locale] Locale for the degrees
     * @param {Object} [options] Angular Options for the request
     */
    get(locale, options) {
        return this.http.get(buildUrl(`${this.baseUrl}/api/degrees`, { locale }), options);
    }
}
DegreeWebservice.ɵfac = function DegreeWebservice_Factory(t) { return new (t || DegreeWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(SCHOOL_API_CONFIG)); };
DegreeWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DegreeWebservice, factory: DegreeWebservice.ɵfac });
DegreeWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [SCHOOL_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DegreeWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [SCHOOL_API_CONFIG]
            }] }]; }, null); })();

const CONTENT_API_CONFIG = new InjectionToken('CONTENT_API_CONFIG');

class ContentLegalWebservice {
    constructor(httpClient, { baseUrl, locale }) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
        this.locale = locale;
    }
    getVersionsByServiceAndType(serviceId, type, options) {
        const service = type === ArticleTypes.CGU ? 'global' : serviceId;
        return this.httpClient.get(`${this.baseUrl}/v1/version/legal-galaxy/${type}/${service}/${this.locale}`, options);
    }
}
ContentLegalWebservice.ɵfac = function ContentLegalWebservice_Factory(t) { return new (t || ContentLegalWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(CONTENT_API_CONFIG)); };
ContentLegalWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ContentLegalWebservice, factory: ContentLegalWebservice.ɵfac });
ContentLegalWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [CONTENT_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContentLegalWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [CONTENT_API_CONFIG]
            }] }]; }, null); })();

class ContentWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    getContributor(contributorId) {
        return this.http.get(`${this.baseUrl}/v1/contributor/${contributorId}`);
    }
    getArticle(articleSlug) {
        return this.http.get(`${this.baseUrl}/v1/facade/${articleSlug}`);
    }
    getFaqArticle(articleSlug) {
        return this.http.get(`${this.baseUrl}/v1/facade/${articleSlug}`);
    }
    getCategory(categorySlug) {
        return this.http.get(`${this.baseUrl}/v1/facet/wizbii-drive-category-${categorySlug}`);
    }
    getArticlesByBlogId(blogId, options) {
        return this.http.get(`${this.baseUrl}/v1/facades/${blogId}`, options);
    }
}
ContentWebservice.ɵfac = function ContentWebservice_Factory(t) { return new (t || ContentWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(CONTENT_API_CONFIG)); };
ContentWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ContentWebservice, factory: ContentWebservice.ɵfac });
ContentWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [CONTENT_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContentWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [CONTENT_API_CONFIG]
            }] }]; }, null); })();

class ContentAdvicesApiWebservice {
    constructor(http, { baseUrl, blogId }) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.blogId = blogId;
    }
    getArticles(parameters) {
        const { categories, offset, rows } = parameters;
        const urlBuilding = buildUrl(`${this.baseUrl}/v2/facades/${this.blogId}`, {
            categories: categories === null || categories === void 0 ? void 0 : categories.join(),
            offset,
            rows,
        });
        return this.http.get(urlBuilding);
    }
    getRecommendedArticles(articleSlug) {
        return this.http.get(`${this.baseUrl}/v1/facades/${this.blogId}/recommended/${articleSlug}`);
    }
    getArticlesById(articleId) {
        return this.http.get(`${this.baseUrl}/v1/facade/${this.blogId}-${articleId}`);
    }
}
ContentAdvicesApiWebservice.ɵfac = function ContentAdvicesApiWebservice_Factory(t) { return new (t || ContentAdvicesApiWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(CONTENT_API_CONFIG)); };
ContentAdvicesApiWebservice.ɵprov = i0.ɵɵdefineInjectable({ factory: function ContentAdvicesApiWebservice_Factory() { return new ContentAdvicesApiWebservice(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CONTENT_API_CONFIG)); }, token: ContentAdvicesApiWebservice, providedIn: "root" });
ContentAdvicesApiWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [CONTENT_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContentAdvicesApiWebservice, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [CONTENT_API_CONFIG]
            }] }]; }, null); })();

const ACCOUNT_API_CONFIG = new InjectionToken('ACCOUNT_API_CONFIG');
class AccountWebservice {
    constructor(httpClient, { baseUrl, baseUrlHost, appId, locale }, document) {
        this.httpClient = httpClient;
        this.document = document;
        this.appId = appId;
        this.baseUrl = baseUrl;
        this.locale = locale;
        this.baseUrlHosted = baseUrlHost.replace('%host%', this.getDomain());
    }
    /**
     * Get Wizbii services (Drive, Fibii ...)
     */
    getServicesList(options) {
        return this.httpClient.get(`${this.baseUrl}/v1/services/${this.locale}`, options);
    }
    /**
     * Delete a Wizbii service (Drive, Fibii ...)
     * @param {string} appId appId
     */
    deleteService(appId, options) {
        return this.httpClient.delete(`${this.baseUrl}/v1/services/delete/${appId}`, options);
    }
    /**
     * Delete from admiin a Wizbii service (Drive, Fibii ...)
     * @param {string} appId appId
     * @param {string} id user id
     */
    adminDeleteService(appId, id, options) {
        return this.httpClient.delete(`${this.baseUrl}/v1/services/delete/${appId}/${id}`, options);
    }
    /**
     * Get an identity card by its ID
     * @param {string} identityCardId ID of the identity card
     */
    getIdentityCard(identityCardId, options) {
        return this.httpClient
            .get(`${this.baseUrl}/v1/identity-card/${identityCardId}`, options)
            .pipe(map(toIdentityCard));
    }
    /**
     * Get email preferences
     * @param {string} userId ID of the user
     */
    getEmailPreferences(userId, options) {
        return this.httpClient.get(`${this.baseUrl}/v2/email-preferences/${userId}`, options);
    }
    /**
     * Update email preferences
     * @param {string} userId ID of the user
     */
    updateEmailPreferences(userId, preference, options) {
        return this.httpClient.patch(`${this.baseUrl}/v2/email-preferences/${userId}`, Object.assign(Object.assign({}, preference), { appId: this.appId }), options);
    }
    /**
     * Get all the role
     */
    getRoles(options) {
        return this.httpClient.get(`${this.baseUrl}/v1/roles`, options);
    }
    /**
     * Get roles of user
     * @param {string} userId ID of the user
     */
    getMemberRoles(userId, options) {
        return this.httpClient.get(`${this.baseUrl}/v1/roles/${userId}`, options);
    }
    /**
     * Add role to user
     * @param {string} userId ID of the user
     * @param {{role:string}} role ID of the user
     */
    addRole(userId, role, options) {
        return this.httpClient.post(`${this.baseUrl}/v1/roles/${userId}/add-role`, role, options);
    }
    /**
     * Remove role to user
     * @param {string} userId ID of the user
     * @param {{role:string}} role ID of the user
     */
    removeRole(userId, role, options) {
        return this.httpClient.post(`${this.baseUrl}/v1/roles/${userId}/remove-role`, role, options);
    }
    /**
     *
     * @param {string} profileId id of the profie
     * @param {string[]} deleteReasons : reasons of the delete
     * @param {string} deleteMessage: message
     * @param {Object} [options] Angular Options for the request
     */
    deleteAccount(profileId, reasons, message, options) {
        return this.httpClient.post(`${this.baseUrl}/v1/account/${profileId}/delete`, { reasons, message }, options);
    }
    /**
     * Recover an account
     * @param {string} recoveryToken token to recover the account
     * @param {string} appId app-id when the account must be recover
     */
    recoverAccount(recoveryToken, appId = 'jobs', options) {
        return this.httpClient.post(`${this.baseUrl}/v1/account/recover`, {
            recoveryToken,
            appId,
        }, options);
    }
    /**
     * Update an identity card
     * @param {IdentityCard} identityCard updated identity card
     */
    updateIdentityCard(identityCard, options) {
        return this.httpClient.put(`${this.baseUrl}/v1/identity-card/${identityCard.id}`, identityCard, options);
    }
    /**
     * get personal data
     * @param {string[]} appIds array of appId of the data requested
     * @param {string} locale locale
     * @param {Object} [options] Angular Options for the request
     */
    getPersonalData(appIds, locale, options) {
        return this.httpClient.post(`${this.baseUrl}/v1/personal-data/request-export-account`, {
            appIds,
            locale,
        }, options);
    }
    /**
     * get authentification chain
     * @param {string} username username to sign in
     * @param {string} password password to sign in
     * @param {string} finalUrl url where you want to be redirected at the end
     * @param {Object} [options] Angular Options for the request
     */
    getAuthentificationChain(username, password, finalUrl, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/login`, {
            username,
            password,
            finalUrl,
        }, options);
    }
    /**
     * get register chain
     * @param {Object} account the account to create
     * @param {string} finalUrl url where you want to be redirected at the end
     * @param {Object} [options] Angular Options for the request
     */
    getRegisterChain(account, finalUrl, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/account`, Object.assign(Object.assign({}, account), { locale: account.locale ? account.locale : LocaleEnum.fr_FR, appId: account.appId ? account.appId : 'account', finalUrl }), options);
    }
    /**
     *
     * @param {string} userId The user id of the people
     * @param {string} source The source to set
     * @param {Object} [options] Angular Options for the request
     * @returns
     */
    setSource(userId, source, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/account/${userId}/source`, { source }, options);
    }
    /**
     * get logout chain
     * @param {string} finalUrl url where you want to be redirected at the end
     * @param {Object} [options] Angular Options for the request
     */
    getLogoutChain(finalUrl, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/logout`, {
            finalUrl,
        }, options);
    }
    /**
     * get authentification chain with login token
     * @param {string} loginToken the login token to sign with
     * @param {string} finalUrl url where you want to be redirected at the end
     * @param {Object} [options] Angular Options for the request
     */
    getAuthentificationChainWithLoginToken(loginToken, finalUrl, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/login-by-token`, {
            finalUrl,
            loginToken,
        }, Object.assign({}, options));
    }
    /**
     * Get the final redirection from login
     * @param {string} encodedChain return from getAuthentificationChain
     * @param {Object} [options] Angular Options for the request
     */
    getLoginRedirect(encodedChain, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/login/process`, { encodedChain }, options);
    }
    /**
     * Get the final redirection from logout
     * @param {string} encodedChain return from getAuthentificationChain
     * @param {Object} [options] Angular Options for the request
     */
    getLogoutRedirect(encodedChain, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/logout/process`, { encodedChain }, options);
    }
    /**
     * Get the final redirection from login
     * @param {string} accessToken return from facebook SDK
     * @param {string} finalUrl url where you want to be redirected at the end
     * @param {string} appId appId
     * @param {string} source the dource
     * @param {Object} [options] Angular Options for the request
     */
    facebookConnect(accessToken, finalUrl, appId, source, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/login-by-facebook`, {
            finalUrl,
            socialAccount: {
                accessToken,
                locale: this.locale,
                appId,
                source,
            },
        }, options);
    }
    /**
     * Get the final redirection from login
     * @param {string} authCode return from google connect SDK
     * @param {string} finalUrl url where you want to be redirected at the end
     * @param {string} appId appId
     * @param {string} source the dource
     * @param {Object} [options] Angular Options for the request
     */
    googleConnect(authCode, finalUrl, appId, source, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/login-by-google`, {
            finalUrl,
            socialAccount: {
                authCode,
                locale: this.locale,
                appId,
                source,
            },
        }, options);
    }
    /**
     * Get the final redirection from login
     * @param {SignInWithAppleData} appleData
     * @param {string} finalUrl url where you want to be redirected at the end
     * @param {string} appId appId initiating the request
     * @param {string} source the dource
     * @param {Object} [options] Angular Options for the request
     */
    appleConnect(appleData, finalUrl, appId, source, options) {
        return this.httpClient.post(`${this.baseUrlHosted}/v1/login-by-apple`, {
            socialAccount: Object.assign(Object.assign({}, appleData), { locale: this.locale, appId,
                source }),
            finalUrl,
        }, options);
    }
    getDomain() {
        const hostnameArray = this.document.location.hostname.split('.');
        return hostnameArray.splice(-hostnameArray.length + 1).join('.');
    }
}
AccountWebservice.ɵfac = function AccountWebservice_Factory(t) { return new (t || AccountWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ACCOUNT_API_CONFIG), ɵngcc0.ɵɵinject(DOCUMENT)); };
AccountWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AccountWebservice, factory: AccountWebservice.ɵfac });
AccountWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [ACCOUNT_API_CONFIG,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [ACCOUNT_API_CONFIG]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

const CONSENT_API_CONFIG = new InjectionToken('CONSENT_API_CONFIG');

class ConsentWebservice {
    constructor(window, { baseUrl, appId }, http, contentLegalWebservice) {
        this.window = window;
        this.http = http;
        this.contentLegalWebservice = contentLegalWebservice;
        this.baseUrl = baseUrl;
        this.appId = appId;
    }
    getAll(userId, token, appId, options) {
        if (!userId) {
            return of(null);
        }
        if (!token) {
            return this.http.get(`${this.baseUrl}/v2/consent/${userId}/${appId ? appId : this.appId}`, Object.assign(Object.assign({}, options), { withCredentials: true }));
        }
        return this.http.get(`${this.baseUrl}/v2/consent/${userId}/${this.appId}`, Object.assign(Object.assign({}, options), { withCredentials: true, headers: {
                'x-auth-token': token,
                'x-auth-type': 'jwt',
            } }));
    }
    transformToMember(visitorId, token, options) {
        if (!token || token.trim() === '') {
            return throwError('User not connected');
        }
        return this.http.post(`${this.baseUrl}/v2/consent/transform/${visitorId}`, null, Object.assign(Object.assign({}, options), { withCredentials: true, headers: {
                'x-auth-token': token,
                'x-auth-type': 'jwt',
            } }));
    }
    sendLastVersionsConsent(value, type, options) {
        const service = type === ArticleTypes.CGU ? 'global' : this.appId;
        return this.contentLegalWebservice.getVersionsByServiceAndType(service, type, options).pipe(switchMap((version) => from(this.window.WizbiiGdpr.saveConsent({
            key: type,
            value,
            lastVersion: version && version.lastVersion ? version.lastVersion : null,
        }))), map((consent) => consent));
    }
    sendLastVersionsConsents(consents, options) {
        return combineLatest(consents.map(({ type }) => this.contentLegalWebservice.getVersionsByServiceAndType(type === ArticleTypes.CGU ? 'global' : this.appId, type, options))).pipe(switchMap((versions) => {
            const consentsToSend = consents.map(({ type: key, value }, index) => ({
                key,
                value,
                lastVersion: versions[index] && versions[index].lastVersion ? versions[index].lastVersion : null,
            }));
            return from(this.window.WizbiiGdpr.saveAllConsents(consentsToSend)).pipe(map(() => consentsToSend));
        }));
    }
    sendAllConsentsWithLastVersionsConsent(consents, type, value, options) {
        const service = type === ArticleTypes.CGU ? 'global' : this.appId;
        return this.contentLegalWebservice.getVersionsByServiceAndType(service, type, options).pipe(switchMap((version) => from(this.window.WizbiiGdpr.saveAllConsents([
            ...consents,
            {
                key: type,
                value,
                lastVersion: version && version.lastVersion ? version.lastVersion : null,
            },
        ]))));
    }
}
ConsentWebservice.ɵfac = function ConsentWebservice_Factory(t) { return new (t || ConsentWebservice)(ɵngcc0.ɵɵinject(WINDOW), ɵngcc0.ɵɵinject(CONSENT_API_CONFIG), ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ContentLegalWebservice)); };
ConsentWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ConsentWebservice, factory: ConsentWebservice.ɵfac });
ConsentWebservice.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [CONSENT_API_CONFIG,] }] },
    { type: HttpClient },
    { type: ContentLegalWebservice }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConsentWebservice, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [CONSENT_API_CONFIG]
            }] }, { type: ɵngcc3.HttpClient }, { type: ContentLegalWebservice }]; }, null); })();

const SUGGESTIONS_API_CONFIG = new InjectionToken('SUGGESTIONS_API_CONFIG');

class SuggestionsWebservice {
    constructor(httpClient, { baseUrl }) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
    }
    getFirstQuestion(suggestionSetId, userId, userType = 'visitor', options) {
        return this.httpClient.post(`${this.baseUrl}/questions/${suggestionSetId}/${userType}/${userId}/first`, {}, options);
    }
    getQuestion(questionId, locale = LocaleEnum.fr_FR, options) {
        return this.httpClient.get(`${this.baseUrl}/questions/${locale}/${questionId}`, options);
    }
    getQuestions(questionIds, locale = LocaleEnum.fr_FR, options) {
        return this.httpClient.get(`${this.baseUrl}/collection-question/${locale}/${questionIds}`, options);
    }
    answerQuestion(questionId, value, suggestionSetId, userId, userType = 'visitor', options) {
        return this.httpClient.post(`${this.baseUrl}/questions/${suggestionSetId}/${userType}/${userId}/next`, {
            questionId,
            value,
        }, options);
    }
    revertDatabag(suggestionSetId, userId, userType = 'visitor', options) {
        return this.httpClient.post(`${this.baseUrl}/questions/${suggestionSetId}/${userType}/${userId}/revert`, null, options);
    }
    getSuggestions(suggestionSetId, userId, userType = 'visitor', options) {
        return this.httpClient.get(`${this.baseUrl}/suggestions/${suggestionSetId}/${userType}/${userId}/suggestions`, options);
    }
    getSuggestion(suggestionId, userId, userType = 'member', options) {
        return this.httpClient.get(`${this.baseUrl}/suggestions/${userType}/${userId}/${suggestionId}`, options);
    }
    /**
     * @param suggestionIds Array of suggestion ids
     * @param options HttpClient options
     */
    getSuggestionByIds(suggestionIds, options) {
        var _a;
        const params = Object.assign(Object.assign({}, ((_a = options === null || options === void 0 ? void 0 : options.params) !== null && _a !== void 0 ? _a : {})), { suggestionIds: suggestionIds.join(',') });
        return this.httpClient.get(`${this.baseUrl}/suggestions`, Object.assign(Object.assign({}, options), { params }));
    }
    getSuggestionsCount(suggestionSetId, options) {
        return this.httpClient.get(`${this.baseUrl}/suggestions/${suggestionSetId}/count`, options);
    }
    getQuestionsWithResponses(suggestionSetId, userId, userType = 'visitor', options) {
        return this.httpClient.get(`${this.baseUrl}/questions/${suggestionSetId}/${userType}/${userId}`, options);
    }
    getQuestionWithResponse(suggestionSetId, userId, questionId, userType = 'visitor', options) {
        return this.httpClient.get(`${this.baseUrl}/questions/${suggestionSetId}/${userType}/${userId}/${questionId}`, options);
    }
    clearUserData(userId, userType = 'visitor', options) {
        return this.httpClient.patch(`${this.baseUrl}/userData/${userType}/${userId}`, null, options);
    }
    downloadUserPdf(userId, userType, suggestionSetId) {
        return this.httpClient.get(`${this.baseUrl}/anwsers/${suggestionSetId}/${userType}/${userId}/pdf`, {
            responseType: 'blob',
        });
    }
    downloadUserAdditionalPdf(userId, userType, suggestionId, locale = LocaleEnum.fr_FR) {
        return this.httpClient.get(`${this.baseUrl}/anwsers/${locale}/${userType}/${userId}/${suggestionId}/pdf`, {
            responseType: 'blob',
        });
    }
    getUserAdditionalDocuments(userId, userType, suggestionId, locale = LocaleEnum.fr_FR) {
        return this.httpClient.get(`${this.baseUrl}/additional-questions/answers/documents/${locale}/${userType}/${userId}/${suggestionId}`);
    }
    getUserAdditionalSensibleQuestionById(userId, userType, suggestionId, locale = LocaleEnum.fr_FR) {
        return this.httpClient.get(`${this.baseUrl}/additional-questions/answers/sensible/${locale}/${userType}/${userId}/${suggestionId}`);
    }
    getUserAdditionalBankerQuestionById(userId, userType, suggestionId, locale = LocaleEnum.fr_FR) {
        return this.httpClient.get(`${this.baseUrl}/additional-questions/answers/banker/${locale}/${userType}/${userId}/${suggestionId}`);
    }
    getUserAdditionalKYCQuestionById(userId, userType, suggestionId, locale = LocaleEnum.fr_FR) {
        return this.httpClient.get(`${this.baseUrl}/additional-questions/answers/kyc/${locale}/${userType}/${userId}/${suggestionId}`);
    }
    getIneligibleSuggestions(userId, userType = 'member', locale = LocaleEnum.fr_FR) {
        return this.httpClient.get(`${this.baseUrl}/helps/${locale}/${userType}/${userId}`);
    }
    getOrganizations() {
        return this.httpClient.get(`${this.baseUrl}/organizations`);
    }
    getEligibilityFormResponses(suggestionSetId, userId, userType = 'member') {
        return this.httpClient.get(`${this.baseUrl}/answers/${suggestionSetId}/${userType}/${userId}`);
    }
    getComplementaryFormResponses(suggestionId, userId, userType = 'member', locale = LocaleEnum.fr_FR) {
        return this.httpClient.get(`${this.baseUrl}/additional/answers/${locale}/${userType}/${userId}/${suggestionId}`);
    }
    getUserComplementaryFormResponse(questionId, userId, userType = 'member') {
        return this.httpClient.get(`${this.baseUrl}/user-data-additional/${userType}/${userId}/${questionId}`);
    }
    postUserComplementaryFormResponse(questionId, responseValue, userId, userType = 'member') {
        return this.httpClient.post(`${this.baseUrl}/user-data-additional/question/${userType}/${userId}`, {
            questionId,
            value: responseValue,
        });
    }
    getUserComplementaryFormState(suggestionId, userId, questionId, userType = 'member') {
        return this.httpClient.post(`${this.baseUrl}/additional-questions/state/${userType}/${userId}/${suggestionId}`, Object.assign({}, (!!questionId && { currentQuestionId: questionId })));
    }
}
SuggestionsWebservice.ɵfac = function SuggestionsWebservice_Factory(t) { return new (t || SuggestionsWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(SUGGESTIONS_API_CONFIG)); };
SuggestionsWebservice.ɵprov = i0.ɵɵdefineInjectable({ factory: function SuggestionsWebservice_Factory() { return new SuggestionsWebservice(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(SUGGESTIONS_API_CONFIG)); }, token: SuggestionsWebservice, providedIn: "root" });
SuggestionsWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [SUGGESTIONS_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuggestionsWebservice, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [SUGGESTIONS_API_CONFIG]
            }] }]; }, null); })();

const SUBSCRIPTION_API_CONFIG = new InjectionToken('SUBSCRIPTION_API_CONFIG');

class SubscriptionWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    getFolders(options) {
        return this.http.get(`${this.baseUrl}/v1/folders-for-account`, options);
    }
    getCampaigns(appId, options) {
        return this.http.get(`${this.baseUrl}/v1/campaigns-by-app/${appId}`, options);
    }
}
SubscriptionWebservice.ɵfac = function SubscriptionWebservice_Factory(t) { return new (t || SubscriptionWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(SUBSCRIPTION_API_CONFIG)); };
SubscriptionWebservice.ɵprov = i0.ɵɵdefineInjectable({ factory: function SubscriptionWebservice_Factory() { return new SubscriptionWebservice(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(SUBSCRIPTION_API_CONFIG)); }, token: SubscriptionWebservice, providedIn: "root" });
SubscriptionWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [SUBSCRIPTION_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SubscriptionWebservice, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [SUBSCRIPTION_API_CONFIG]
            }] }]; }, null); })();

const EMAIL_API_CONFIG = new InjectionToken('EMAIL_API_CONFIG');

class EmailWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    /**
     * Get user received email list
     * @param {Object} [options] Angular Options for the request
     */
    getEmails(options) {
        return this.http.get(`${this.baseUrl}/v1/email`, options);
    }
    /**
     * Get an email details
     * @param emailId Email identifier
     * @param {Object} [options] Angular Options for the request
     */
    getEmailById(emailId, options) {
        return this.http.get(`${this.baseUrl}/v1/email/${emailId}`, options);
    }
}
EmailWebservice.ɵfac = function EmailWebservice_Factory(t) { return new (t || EmailWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(EMAIL_API_CONFIG)); };
EmailWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: EmailWebservice, factory: EmailWebservice.ɵfac });
EmailWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [EMAIL_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EmailWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [EMAIL_API_CONFIG]
            }] }]; }, null); })();

const FIBII_API_CONFIG = new InjectionToken('FIBII_API_CONFIG');

class FibiiWebservice {
    constructor(httpClient, { baseUrl }) {
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
    }
    updateDossierStatus(userId, suggestionId, status, options) {
        return this.httpClient.patch(`${this.baseUrl}/dossiers/${userId}/client/${suggestionId}`, { status }, options);
    }
    updateDossierStatusV2(userId, suggestionId, status, options) {
        return this.httpClient.patch(`${this.baseUrl}/v2/dossiers/${userId}/client/${suggestionId}`, { status }, options);
    }
    updateDossierArchiveStatus(userId, suggestionId, isArchived, reason, options) {
        return this.httpClient.patch(`${this.baseUrl}/v2/dossiers/${userId}/client/${suggestionId}/archive`, { isArchived, reason }, options);
    }
    getDossiers() {
        return this.httpClient.get(`${this.baseUrl}/dossiers`);
    }
    validateDepotInformations(userId, suggestionId) {
        return this.httpClient.patch(`${this.baseUrl}/dossiers/${userId}/mandate/${suggestionId}`, {});
    }
    getNextSuggestionToUpdate(userId) {
        return this.httpClient.get(`${this.baseUrl}/dossiers/update-data/${userId}`);
    }
}
FibiiWebservice.ɵfac = function FibiiWebservice_Factory(t) { return new (t || FibiiWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(FIBII_API_CONFIG)); };
FibiiWebservice.ɵprov = i0.ɵɵdefineInjectable({ factory: function FibiiWebservice_Factory() { return new FibiiWebservice(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(FIBII_API_CONFIG)); }, token: FibiiWebservice, providedIn: "root" });
FibiiWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [FIBII_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FibiiWebservice, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [FIBII_API_CONFIG]
            }] }]; }, null); })();

const OPS_EVENT_API_CONFIG = new InjectionToken('OPS_EVENT_API_CONFIG');

class EventWebservice {
    constructor(http, { baseUrl }) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    getEventById(eventId, options) {
        return this.http
            .get(`${this.baseUrl}/api/event/${eventId}`, options)
            .pipe(map(toOpsEvent));
    }
    getEventDescription(eventId, options) {
        return this.http
            .get(`${this.baseUrl}/api/event/${eventId}/preview-description`, options)
            .pipe(map((payload) => payload.description));
    }
    getAllEvents(options) {
        return this.http
            .get(`${this.baseUrl}/api/events/list/incoming-light-illustrated`, options)
            .pipe(map((response) => response.map(toOpsEventLight)));
    }
    getEventTypes(options) {
        return this.http.get(`${this.baseUrl}/api/event-types`, options);
    }
}
EventWebservice.ɵfac = function EventWebservice_Factory(t) { return new (t || EventWebservice)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(OPS_EVENT_API_CONFIG)); };
EventWebservice.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: EventWebservice, factory: EventWebservice.ɵfac });
EventWebservice.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [OPS_EVENT_API_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EventWebservice, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [OPS_EVENT_API_CONFIG]
            }] }]; }, null); })();

//// Algolia

/**
 * Generated bundle index. Do not edit.
 */

export { ACCOUNT_API_CONFIG, AUTHENTICATION_API_CONFIG, AccountWebservice, AlgoliaWebservice, AuthenticationApiError, AuthenticationWebservice, COMPANY_API_CONFIG, CONSENT_API_CONFIG, CONTACT_API_CONFIG, CONTENT_API_CONFIG, CityWebservice, ConsentWebservice, ContactWebservice, ContentAdvicesApiWebservice, ContentLegalWebservice, ContentWebservice, ContractWebservice, DegreeWebservice, EMAIL_API_CONFIG, EmailWebservice, EventWebservice, FIBII_API_CONFIG, FILE_API_CONFIG, FibiiWebservice, FileWebservice, JOB_API_CONFIG, JobWebservice, OPS_EVENT_API_CONFIG, PLACE_API_CONFIG, PROFILE_API_CONFIG, ProfileWebservice, SCHOOL_API_CONFIG, SUBSCRIPTION_API_CONFIG, SUGGESTIONS_API_CONFIG, SubscriptionWebservice, SuggestionsWebservice, CompanyWebservice as WizCompanyWebservice };

